import { deserialize } from '@cherre-frontend/data-fetching';
import qs from 'qs';

export const customParamSearchConnectorOverview = (search: string) => {
  let searchParams;
  try {
    searchParams = deserialize(search);
  } catch {
    searchParams = qs.parse(search);
    const decoded = btoa(JSON.stringify(searchParams));
    window.history.pushState('', '', `?${decoded}`);
  }

  return searchParams;
};
